// import {message} from 'antd'
// import { setMessage } from '@/actions/auth'
// import store from '@/store'
// import { logoutUser } from '@/actions/user';

import {toast} from 'react-toastify'

const handleApiError = (error, props = {}) => {
  const {history} = props

  // let path = window.location.pathname;

  if (error.response) {
    const {data, status} = error.response

    switch (status) {
      case 401:
        // toast.error('Token expired atau akun sedang digunakan pada perangkat lain.', {
        //   autoClose: 5000,
        // })
        props('/auth')
        // localStorage.clear()
        break

      case 403:
        //set redux auth message & redirect to 403 page
        //   store.dispatch(setMessage(data.message))
        //   store.dispatch(replace('/403'))
        if (history) history.replace('/403')
        break

      default:
        break
    }
  }
}

export default handleApiError
